import { getOrganisation } from '@/libs/api/api'
import {getImageUrl, onError} from '@/libs/helper'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import { isEmpty } from 'lodash';

export default {
    name: 'ShortURLHome',
    created() {
        // fetch organisations
        this.fetchOrganisations()
    },
    data () {
        return {
            onError,
            getImageUrl,
            details: {},
            owners: []
        }
    },
    methods: {
        /**
         * fetch the list of organisations
         */
         fetchOrganisations () {
            getOrganisation().then(response => {
                // initialise
                this.metaList = response || []
                // set list in store
                let owners = response.filter(org => org.role === constants.ORGANISATION_RIGHTS.OWNER)
                this.$store.dispatch('setOrganisations', owners)
                this.owners = owners || []
                this.details = owners && owners.length > 0 ? owners[0] : {}
                localStorage.setItem('details', JSON.stringify(this.details))
            })
        },
        /**
         * route to organisation overview page
         * @param {*} organisation 
         */
         routeToOrganisationOverviewPage (organisation) {
            // route
            this.$router.push({name: pageRoute.organisationOverview, params: {id: organisation._id}})
        },

        /**
         * switch organisation
         */
        changeOrganisation (org) {
            if (!isEmpty(org)) this.details = org
        }
    }
}